class NotesReportController {
    constructor($routeParams, $browser, $window, ReportUtilityServiceApi, ReportServiceApi, $uibModal, toastr, moment, UserDetailsApi, SettingsService, $location, ngProgressFactory, UserServiceApi, UtpAttachmentServiceApi, ReportUtils, ScriptInjectionService) {
        this.noteRenderer = (row) => {
            let tempContent = row.data.Content;
            // Check for characters which need to be html escaped before displaying
            // e.g. text like <script>alert("Error")</script>
            if (this.ScriptInjectionService.isInjectedScript(tempContent)) {
                tempContent = this.ScriptInjectionService.escapeHtml(tempContent);
            }
            const note = [
                '<span class="text-mono">',
                tempContent,
                '</span>'
            ].join('');
            return note;
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.csvTimeCellRenderer = (row) => {
            // Add a Z to indicate this is a UTC time + Strictly specify Format of String for FireFox to parse correctly
            // 2016-08-19T14:35:26.283
            // YYYY-MM-DDTHH:mm:ss.S
            const time = [
                this.moment(row.data.TimestampPrevious + 'Z', 'YYYY-MM-DDTHH:mm:ss.SZ')
                    .utc()
                    .format(this.state.DateFormats.DateTimeFormat),
            ].join('');
            return time;
        };
        this.timeCellRenderer = (row) => {
            // Add a Z to indicate this is a UTC time + Strictly specify Format of String for FireFox to parse correctly
            // 2016-08-19T14:35:26.283
            // YYYY-MM-DDTHH:mm:ss.S
            const time = [
                '<span>',
                this.moment(row.data.Timestamp + 'Z', 'YYYY-MM-DDTHH:mm:ss.SZ')
                    .utc()
                    .format(this.state.DateFormats.DateTimeFormat),
                '</span>'
            ].join('');
            return time;
        };
        this.traceRenderer = (row) => {
            let tooltip = 'View Trace Details';
            let action = 'vm.caseTraceDetails(data)';
            let testlink = this.createLink(row.data.TestCaseName, tooltip, action);
            tooltip = 'View Conversation';
            action = 'vm.openConversation(data)';
            const conversationlink = this.createLink('Conversation', tooltip, action);
            const SimName = [
                '<div class="noteText">',
                row.data.SimName,
                '</div>'
            ].join('');
            const TestSuiteName = [
                '<div class="noteText">',
                row.data.TestSuiteName,
                '</div>'
            ].join('');
            const TestCaseName = [
                '<div class="noteText">',
                testlink,
                '</div>'
            ].join('');
            // var UserDescription = [
            //     '<div>',
            //     row.data.UserDescription,
            //     '</div>'
            // ].join('');
            const CreatorDescription = [
                '<div>',
                '<span>',
                '<strong>',
                row.data.CreatorDescription,
                '</strong>',
                '<span>',
                // '<span class="pointer pull-right" ng-click="vm.caseTraceDetails(data)"><i class="glyphicon glyphicon-screenshot"></i></span>',
                '<span class="noteText pull-right">',
                conversationlink,
                '</sspan>',
                '</div>'
            ].join('');
            const traceCell = [
                '<div>',
                CreatorDescription,
                // "&nbsp;",
                SimName,
                TestSuiteName,
                TestCaseName,
                '</div>'
            ].join('');
            return traceCell;
        };
        this.csvTraceRenderer = (row) => {
            const SimName = [
                row.data.SimName + '\r\n'
            ].join('');
            const TestSuiteName = [
                row.data.TestSuiteName + '\r\n'
            ].join('');
            const TestCaseName = [
                row.data.TestCaseName
            ].join('');
            const CreatorDescription = [
                row.data.CreatorDescription + '\r\n'
            ].join('');
            const traceCell = [
                CreatorDescription,
                // "&nbsp;",
                SimName,
                TestSuiteName,
                TestCaseName
            ].join('');
            return traceCell;
        };
        this.createLink = (data, tooltip, action) => {
            const link = [
                '<span',
                'ng-if="!vm.state.linkFromName">',
                data,
                '</span><a ng-href=""',
                'class="space-top pointer"',
                'title="',
                tooltip,
                '"',
                'ng-if="vm.state.linkFromName"',
                'ng-click="',
                action,
                '">',
                data,
                '</a>'
            ].join(' ');
            return link;
        };
        this.getRowHeight = (row) => {
            let minHeight = 65;
            if (this.state.traceAlternateView) {
                minHeight = minHeight + 20;
            }
            const charHeight = 20.75; // height per character
            // var minHeight = charHeight * (Math.floor((row.data.SimName.length + row.data.TestSuiteName.length + row.data.TestCaseName.length + row.data.UserDescription.length + row.data.CreatorDescription.length) / 10) + 1);
            const charsPerRow = 85; // characters that fit per row (should be exact) -- MORE IS LESS HEIGHT TOTAL
            const charRows = row.data.Content.length / charsPerRow; // total rows as a double
            const totalRows = Math.floor(charRows) + 1; // total rows as the lowest integer amount
            const height = charHeight * totalRows;
            if (height <= minHeight) {
                return minHeight;
            } // make sure that the trace content is visible
            return height;
        };
        this.onModelUpdated = () => {
            const model = this.gridOptions.api.getModel();
            const processedRows = model.getRowCount();
            this.rowCount = processedRows;
        };
        this.$onInit = () => {
            this.rowCount = 0;
            this.columnDefs = [
                {
                    headerName: 'Trace',
                    field: 'traceColumn',
                    minWidth: 210,
                    cellRenderer: this.traceRenderer,
                    suppressMenu: true
                },
                {
                    headerName: 'Timestamp',
                    field: 'timeStampColumn',
                    width: 200,
                    minWidth: 160,
                    cellRenderer: this.timeCellRenderer,
                    suppressMenu: true,
                    suppressSizeToFit: true,
                    sort: 'desc'
                },
                {
                    headerName: 'Note',
                    field: 'Content',
                    minWidth: 590,
                    cellRenderer: this.noteRenderer
                }
            ];
            this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.gridOptions.getRowHeight = this.getRowHeight;
            this.state = {
                linkFromName: true,
                showSelectors: true,
                traceAlternateView: true,
                moreOk: true,
                reportRequest: {
                    SimId: 0,
                    TestId: 0,
                    UserId: 0,
                    SuiteId: 0,
                    TraceId: 0,
                    CreatedBy: 0,
                    TraceUid: '',
                    Contains: '',
                    ConversationId: '',
                    FuzzyConversationId: false,
                    // @ts-ignore lodash
                    FromDate: this.moment().subtract(1, 'days')._d, // Get the js date object behind the this.moment for Datepicker to parse correctly
                    // @ts-ignore lodash
                    ToDate: this.moment()._d,
                    ProjectIterationId: 0
                },
                DateFormats: {},
                hideNav: _.startsWith(this.location.path(), '/Reports'),
                showReport: false,
                userDetails: {}
            };
            this.data = {
                notes: []
            };
            // @ts-ignore: Report clashes with dom.lib.d.ts Report
            this.notesReport = {
                Id: 0,
                Name: '',
                Description: 'Notes Report',
                Route: '',
                Component: '',
                Icon: '',
                IsDeleted: false,
                LastAmended: null,
                LastAmendedBy: 0,
                ReportOrder: 0,
                IsExternal: false,
                Filetype: '',
                IdPId: ''
            };
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.datePicker = {
                date: { startDate: null, endDate: null },
                options: {
                    showCustomRangeLabel: false,
                    alwaysShowCalendars: true
                }
            };
            this.traceProgress.start();
            this.SettingsService.getSettings().then((response) => {
                let appSettings = response.data;
                this.state.showReport = true;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat
                };
                this.datePicker.options = {
                    alwaysShowCalendars: true,
                    format: this.state.DateFormats.DateFormat,
                    locale: {
                        cancelLabel: 'Clear'
                    },
                    maxDate: this.moment(),
                    separator: ' to ',
                    eventHandlers: {
                        'apply.daterangepicker': (ev, picker) => {
                            this.selectDateRange(ev, picker);
                        },
                        'cancel.daterangepicker': (ev, picker) => {
                            this.clearDates();
                        }
                    },
                    ranges: {
                        Today: [this.moment(), this.moment()],
                        Yesterday: [
                            this.moment().subtract(1, 'days'),
                            this.moment().subtract(1, 'days')
                        ],
                        'Last 7 Days': [this.moment().subtract(6, 'days'), this.moment()],
                        'Last 30 Days': [
                            this.moment().subtract(29, 'days'),
                            this.moment()
                        ],
                        'This Month': [
                            this.moment().startOf('month'),
                            this.moment().endOf('month')
                        ],
                        'Last Month': [
                            this.moment()
                                .subtract(1, 'month')
                                .startOf('month'),
                            this.moment()
                                .subtract(1, 'month')
                                .endOf('month')
                        ],
                        'Last 3 Months': [
                            this.moment()
                                .subtract(3, 'month')
                                .startOf('month'),
                            this.moment().endOf('month')
                        ]
                    }
                };
                // this.datePicker = {
                //     date: { startDate: null, endDate: null },
                //     options: {
                //         showCustomRangeLabel: false,
                //         alwaysShowCalendars: true
                //     }
                // };
                this.datePicker.date = {
                    startDate: this.moment().subtract(1, 'days'),
                    endDate: this.moment()
                };
            });
            this.UserDetailsApi.get().then((userResponse) => {
                this.state.userDetails = userResponse.data; // setup our user details
                this.UtpAttachmentServiceApi.getNotes(this.state.reportRequest).then((noteResponse) => {
                    this.traceProgress.complete();
                    this.data.notes = this.ReportService.adjustToLocalTime(noteResponse.data, this.state.userDetails.TimezoneOffset);
                    this.gridOptions.api.setRowData(this.data.notes);
                });
            });
            this.ReportServiceApi.getReportByName('NotesReport').then((response) => {
                if (Object.keys(response.data).length > 0) {
                    this.notesReport = response.data;
                }
                else {
                    this.toastr.warning('Report descriptions not found');
                }
            });
        };
        this.getReport = () => {
            this.traceProgress.start();
            this.UtpAttachmentServiceApi.getNotes(this.state.reportRequest).then((noteResponse) => {
                this.traceProgress.complete();
                this.data.notes = this.ReportService.adjustToLocalTime(noteResponse.data, this.state.userDetails.TimezoneOffset);
                this.gridOptions.api.setRowData(this.data.notes);
            });
        };
        // This gets Previous 24 Hours
        this.more = () => {
            // console.log(this.data.notes);
            let FromDate = this.state.reportRequest.FromDate;
            let ToDate = this.state.reportRequest.ToDate;
            this.traceProgress.start();
            if (FromDate == null) {
                // @ts-ignore lodash
                FromDate = this.moment()._d;
            }
            // @ts-ignore lodash
            this.state.reportRequest.FromDate = this.moment(FromDate).subtract(1, 'days')._d;
            this.datePicker.date = {
                startDate: this.state.reportRequest.FromDate,
                endDate: ToDate
            };
            // console.log(this.state.reportRequest);
            this.UtpAttachmentServiceApi.getNotes(this.state.reportRequest).then((noteResponse) => {
                this.traceProgress.complete();
                // @ts-ignore
                this.data.notes = _.concat(noteResponse.data, this.data.notes);
                // @ts-ignore
                this.data.notes = _.uniqBy(this.data.notes, (item) => {
                    return item.Id;
                });
                this.data.notes = this.ReportService.adjustToLocalTime(this.data.notes, this.state.userDetails.TimezoneOffset);
                this.gridOptions.api.setRowData(this.data.notes);
            });
        };
        this.caseTraceDetails = (row) => {
            const mode = { view: false, run: false };
            // console.log(row);
            let selectedItems = {
                selectedTester: { Id: row.UserId, Name: row.UserName },
                selectedSim: { Id: row.SimId, Name: row.SimName },
                selectedSuite: { Id: row.SuiteId, Name: row.TestSuiteName },
                selectedTest: { Id: row.TestId, Name: row.TestCaseName },
                unknownUser: { Id: 0, Name: 'Unknown' },
                fromTester: false
            };
            this.openDetails(selectedItems, mode);
        };
        this.openConversation = (note) => {
            this.uibModal.open({
                animation: true,
                backdrop: 'static',
                keyboard: false,
                component: 'conversationDetailsModalContainerComponent',
                size: 'md',
                resolve: {
                    note: note
                }
            });
        };
        this.setNoteForExport = (note) => {
            note.traceColumn = this.csvTraceRenderer({ data: note });
            note.timeStampColumn = this.csvTimeCellRenderer({ data: note });
            return note;
        };
        this.exportCsv = () => {
            _.forEach(this.data.notes, (note) => {
                note = this.setNoteForExport(note);
            });
            const reportName = this.ReportService.addDateToTitle(this.notesReport.Description + '.csv');
            const params = {
                allColumns: true,
                fileName: reportName
            };
            this.gridOptions.api.exportDataAsCsv(params);
        };
        this.selectDateRange = (ev, picker) => {
            this.state.reportRequest.FromDate = this.moment(this.datePicker.date.startDate)
                .utc()
                .toDate();
            // .toISOString();
            this.state.reportRequest.ToDate = this.moment(this.datePicker.date.endDate)
                .utc()
                .toDate();
            this.state.moreOk = true;
            // .toISOString();
        };
        this.clearDates = () => {
            this.datePicker.date = { startDate: null, endDate: null };
            this.state.reportRequest.ToDate = this.datePicker.date.endDate;
            this.state.reportRequest.FromDate = this.datePicker.date.startDate;
            this.state.moreOk = false;
        };
        this.routeParams = $routeParams;
        this.browser = $browser;
        this.window = $window;
        this.ReportService = ReportUtilityServiceApi;
        this.ReportServiceApi = ReportServiceApi;
        this.uibModal = $uibModal;
        this.toastr = toastr;
        this.moment = moment;
        this.UserDetailsApi = UserDetailsApi;
        this.SettingsService = SettingsService;
        this.location = $location;
        this.ngProgressFactory = ngProgressFactory;
        this.UserServiceApi = UserServiceApi;
        this.UtpAttachmentServiceApi = UtpAttachmentServiceApi;
        this.ReportUtils = ReportUtils;
        this.ScriptInjectionService = ScriptInjectionService;
    }
    openDetails(selectedItems, mode) {
        const tdParams = {
            selectedItems: selectedItems,
            mode: mode,
            user: this.state.userDetails,
            overTheShoulder: false
        };
        let modalInstance = this.uibModal.open({
            animation: true,
            size: 'xl',
            backdrop: 'static',
            keyboard: false,
            component: 'traceDetailsModal',
            resolve: {
                params: () => {
                    return tdParams;
                }
            }
        });
        modalInstance.result.then((response) => {
            // close callback
            console.log('trace-details closed');
        });
    }
}
angular.module('app').component('notesReport', {
    templateUrl: 'Scripts/App/partials/Reports/notes-report.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: NotesReportController
});
